module.exports = "/images/gallery-line-top-left-bottom-right.svg?5874efb5fd22006b6986a9c9f64c4e07";